import { defineStore } from "pinia"
import { useUserStore } from "./user"
import { useContractStore } from "./contract"


export const useRevealStore = defineStore({
    id: 'reveal',
    state: () => ({
        data: null,
        chain_id: 5,
        tokens: [],
        revealed_tokens: [],
        total_revealed_tokens: [],
        total_sealed_tokens: [],
        tokenIdList: [],
        series_revealed: "Series I",
        no_tokens: false,
        is_awrd: false,
        revealed_tokens_test:[{series: 'Series I',image: '/images/worksample.jpg',rarity: 'Common',token_id: 69, url:'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/69'},{series: 'Series I',image: '/images/worksample2.jpg',rarity: 'Rare',token_id: 420, url:'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/420'}],
        series_tokens_test: {s1: {name: 'Series I',tokens: [{image: '/images/worksample.jpg',revealed: true,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 171},{image: '/images/worksample2.jpg',revealed: true,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 172},{image: '/images/worksample.jpg',revealed: false,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 173},{image: '/images/worksample.jpg',revealed: false,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 173},{image: '/images/worksample.jpg',revealed: false,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 173},{image: '/images/worksample.jpg',revealed: false,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 173},{image: '/images/worksample.jpg',revealed: false,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 173},{image: '/images/worksample.jpg',revealed: false,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 173}]},s2: {name: 'Series II',tokens: [{image: '/images/worksample.jpg',revealed: false,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 173},{image: '/images/worksample.jpg',revealed: false,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 173},{image: '/images/worksample.jpg',revealed: false,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 173},{image: '/images/worksample.jpg',revealed: false,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 173},{image: '/images/worksample.jpg',revealed: false,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 173},{image: '/images/worksample.jpg',revealed: false,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 173},{image: '/images/worksample.jpg',revealed: false,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 173},{image: '/images/worksample.jpg',revealed: false,base_url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/',token_id: 173}]}}
    }),
    getters: {
        getData(state){
            return state.data
        },
        getSeriesRevealed(state){
            return state.series_revealed
        },
        getChainId(state){
            return state.chain_id
        },
        getTokens(state){
            return state.tokens
        },
        getTotalRevealedTokens(state){
            return state.tokens.filter(token => token.revealed)
        },
        getTotalSealedTokens(state){
            return state.tokens.filter(token => !token.revealed)
        },
        getRevealedThisSession(state){
            return state.revealed_tokens
        },
        getRevealedThisSessionTokenIDs(state){
            return state.revealed_tokens.map(token => token.token_id)
        },
        getUnrevealedTokens(state){
            return state.tokens.filter(token => {token.revealed})
        },
        getTokenIDList(state){
            return state.tokenIdList
        },
        getHasTokens(state){
            return state.no_tokens
        },
        getIsAWRD(state){
            return state.is_awrd
        },
        getSeriesTokens(state) {
            return state.tokens.reduce((result, token) => {
                const seriesKey = `series_${token.series}`;
                if(!result[seriesKey]) {
                    result[seriesKey] = {
                        name: token.series,
                        tokens: []
                    };
                }

                result[seriesKey].tokens.push({
                    image: token.image,
                    revealed: !!token.revealed,
                    base_url: token.url,
                    token_id: token.token_id
                });

                return result;
            }, {});
        }
    },
    actions: {
        addRevealedToken(token){
            let updatedTokens = this.revealed_tokens
            updatedTokens.push(token)
            this.setRevealedTokens(updatedTokens)
        },
        setData(data){
            this.data = data
            return true
        },
        setTokens(tokens){
            const transformedTokens = Object.keys(tokens)
                .map(key => ({id: key, ...tokens[key]}))
                .map(token => ({
                    series: 'Series ' + 1, 
                    image: token.image_250, 
                    rarity: token.rarity,
                    revealed: token.revealed,
                    url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/' + token.id, 
                    token_id: token.id,
                    name: "WARRIOR " + token.id
                }));
            
            this.tokens = transformedTokens;
            return true;
        },
        setRevealedTokens(tokens){
            this.revealed_tokens = tokens
            return true
        },
        setTokenIDList(token_list){
            this.tokenIdList = token_list
        },
        setNoTokens(has_tokens){
            this.no_tokens = has_tokens
        },
        setIsAWRD(is_awrd){
            this.is_awrd = is_awrd
        },
        setTotalRevealed(total_revealed){
            const revelaed_tokens = Object.keys(total_revealed)
            .filter(key => total_revealed[key].revealed !== false)
            .map(key => ({id:key, ...total_revealed[key]}))
            .map(key => ({
                series: 1, 
                name:'WARRIOR' + key, 
                image:'/images/worksample.jpg',
                id:key, 
                ...total_revealed[key]}))
            this.total_revealed_tokens = revelaed_tokens
            return true
        },
        setTotalSealed(total_sealed){
            const sealed_tokens = Object.keys(total_sealed)
            .filter(key => total_sealed[key].revealed !== true).map(key => ({id:key, ...total_sealed[key]}))
            .map(key => ({series: 1, name:'WARRIOR', image:'/images/s1small.gif', ...total_sealed[key]}))
            this.total_sealed_tokens = sealed_tokens
            return true
        },
        setSeriesRevealed(series_name){
            this.series_revealed = series_name
        },
        async processAccountHoldings(holdings){
            this.setTokenIDList(holdings)
            const url = "https://gs6qnixyf3.execute-api.us-east-1.amazonaws.com/zerg/get_reveal_status"
            const body = {
                token_ids: holdings,
            }
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
            if(response.status !== 200){
                console.debug("ERROR GETTING TOKEN ID STATUS")
            }
            const data = await response.json()
            const setData = this.setData(data)
            const setAll = this.setTokens(data.body.tokens)
            const setRevealed = this.setTotalRevealed(data.body.tokens)
            const setSealed = this.setTotalSealed(data.body.tokens)
            if(setData && setAll && setRevealed && setSealed){
                return true
            } else {
                console.debug('Error setting revealed data')
            }

        },
        async revealTokens(){
            const url = 'https://gs6qnixyf3.execute-api.us-east-1.amazonaws.com/zerg/reveal'
            let token_ids = this.getRevealedThisSessionTokenIDs.map(id => parseInt(id))
            let body = {
                token_ids: token_ids
            }
            const userStore = useUserStore()
            const use_api = userStore.isAWRD
            if(use_api){
                body = {
                    ...body,
                    API_TOKEN: userStore.getAPIKey,
                    APP_KEY: userStore.getAppKey
                }
            } else {
                const contractStore = useContractStore()
                const { address, signature } = await contractStore.getSignature(token_ids)
                body = {
                    ...body,
                    wallet: address,
                    signature: signature
                }
            }
            const response =  await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
            if(response.status !== 200){
                console.debug('ERROR REVEALING TOKENS')
                return false
            }
            const data = await response.json()
            const revealed_success = this.updateRevealedTokens(data.body.tokens)
            return revealed_success
        },
        async updateRevealedTokens(tokens){
            const updatedTokens = Object.keys(tokens)
            .map(key => ({id: key, ...tokens[key]}))
            .map(token => ({
                series: 'Series ' + 1, 
                image: token.image_250, 
                rarity: token.rarity,
                revealed: token.revealed,
                url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/' + token.id, 
                token_id: token.id,
                name: "WARRIOR " + token.id
            }));
            
            updatedTokens.forEach(updatedToken => {
                const tokenIndex = this.tokens.findIndex(token => token.token_id === updatedToken.token_id)
                if (tokenIndex !== -1) this.tokens[tokenIndex] = updatedToken
        
                const revealedIndex = this.revealed_tokens.findIndex(token => token.token_id === updatedToken.token_id)
                if (revealedIndex !== -1) this.revealed_tokens[revealedIndex] = updatedToken
        
                const totalRevealedIndex = this.total_revealed_tokens.findIndex(token => token.token_id === updatedToken.token_id)
                if (totalRevealedIndex !== -1) this.total_revealed_tokens[totalRevealedIndex] = updatedToken
        
                const totalSealedIndex = this.total_sealed_tokens.findIndex(token => token.token_id === updatedToken.token_id)
                if (totalSealedIndex !== -1) this.total_sealed_tokens[totalSealedIndex] = updatedToken
                
                Object.values(this.series_tokens_test).forEach(series => {
                    const seriesIndex = series.tokens.findIndex(token => token.token_id === updatedToken.token_id)
                    if (seriesIndex !== -1) series.tokens[seriesIndex] = updatedToken
                })
            })
            
            return true
        }
        
        // async updateRevealedTokens(tokens){
        //     console.debug(tokens)
        //     const updatedTokens = Object.keys(tokens)
        //     .map(key => ({id: key, ...tokens[key]}))
        //     .map(token => ({
        //         series: 'Series ' + 1, 
        //         image: token.image, 
        //         rarity: "Common",
        //         revealed: token.revealed,
        //         url: 'https://opensea.io/assets/ethereum/0x37dcb94bbe2d5a148beffeae1eba59e7508edafd/' + token.id, 
        //         token_id: token.id,
        //         name: "WARRIOR " + token.id
        //     }))
        //     this.revealed_tokens = updatedTokens
        //     this.total_revealed_tokens = updatedTokens.filter(token => token.revealed)
        //     this.total_sealed_tokens = updatedTokens.filter(token => !token.revealed)

        //     return true
        // }
    },
})